package team.platforma.dictionarydata.table

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AiChapterQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (id: Long, name: String) -> T): Query<T> =
      Query(-1_505_090_565, arrayOf("AiChapter"), driver, "AiChapter.sq", "selectAll",
      "SELECT AiChapter.id, AiChapter.name FROM AiChapter") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!
    )
  }

  public fun selectAll(): Query<AiChapter> = selectAll { id, name ->
    AiChapter(
      id,
      name
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun addChapter(id: Long?, name: String): Long {
    val result = driver.execute(595_634_742, """
        |INSERT OR REPLACE INTO AiChapter(id, name)
        |VALUES (?, ?)
        """.trimMargin(), 2) {
          bindLong(0, id)
          bindString(1, name)
        }.await()
    notifyQueries(595_634_742) { emit ->
      emit("AiChapter")
    }
    return result
  }
}
